// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.Redlining  > div.body {
    width: 100%;
}

div.redlining-buttongroups {
    display: flex;
    align-items: center;
    margin: 0 -0.125em;
}

div.redlining-separator {
    border-bottom: 1px solid var(--border-color);
    margin-bottom: 0.25em;
}

div.redlining-group {
    margin: 0;
    flex: 1 1 auto;
    margin: 0 0.125em;
}

div.redlining-group > div:first-child {
    font-size: 85%;
    text-align: center;
}

div.redlining-group > div:last-child {
    margin: 0.25em 0;
}

div.redlining-group > div {
    white-space: nowrap;
}

div.redlining-group > span {
    display: flex;
    justify-content: center;
    margin: auto;
}

div.redlining-group > span > * {
    flex: 1 0 auto;
}

div.redlining-export-menu {
    height: 2em;
    margin: 0.25em 0;
}

div.redlining-export-menu-entry {
    font-size: 90%;
}

div.redlining-controlsbar {
    display: flex;
}

div.redlining-controlsbar > span {
    display: inline-flex;
    flex: 0 0 auto;
    align-items: center;
    justify-content: center;
    margin: 0 0.25em;
}

div.redlining-controlsbar input.redlining-label,
div.redlining-controlsbar select.redlining-unit {
    flex: 1 1 auto;
    width: 0;
    min-width: 5em;
}

div.redlining-shapewarning {
    border-top: 1px solid var(--border-color);
    margin-top: 0.25em;
    padding-top: 0.25em;
    font-size: 90%;
    font-style: italic;
}

span.redlining-control-icon {
    margin-right: 0.125em;
}

div.redlining-marker-combo-entry {
    display: flex;
    align-items: center;
    height: 16px;
    width: 16px;
}

div.redlining-marker-combo-entry img {
    /* Marker images are white, invert them to black */
    filter: invert(1);
    height: 100%;
}

div.redlining-message {
    text-align: center;
    font-style: italic;
}`, "",{"version":3,"sources":["webpack://./plugins/style/Redlining.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,4CAA4C;IAC5C,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;;IAEI,cAAc;IACd,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,yCAAyC;IACzC,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kDAAkD;IAClD,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB","sourcesContent":["div.Redlining  > div.body {\n    width: 100%;\n}\n\ndiv.redlining-buttongroups {\n    display: flex;\n    align-items: center;\n    margin: 0 -0.125em;\n}\n\ndiv.redlining-separator {\n    border-bottom: 1px solid var(--border-color);\n    margin-bottom: 0.25em;\n}\n\ndiv.redlining-group {\n    margin: 0;\n    flex: 1 1 auto;\n    margin: 0 0.125em;\n}\n\ndiv.redlining-group > div:first-child {\n    font-size: 85%;\n    text-align: center;\n}\n\ndiv.redlining-group > div:last-child {\n    margin: 0.25em 0;\n}\n\ndiv.redlining-group > div {\n    white-space: nowrap;\n}\n\ndiv.redlining-group > span {\n    display: flex;\n    justify-content: center;\n    margin: auto;\n}\n\ndiv.redlining-group > span > * {\n    flex: 1 0 auto;\n}\n\ndiv.redlining-export-menu {\n    height: 2em;\n    margin: 0.25em 0;\n}\n\ndiv.redlining-export-menu-entry {\n    font-size: 90%;\n}\n\ndiv.redlining-controlsbar {\n    display: flex;\n}\n\ndiv.redlining-controlsbar > span {\n    display: inline-flex;\n    flex: 0 0 auto;\n    align-items: center;\n    justify-content: center;\n    margin: 0 0.25em;\n}\n\ndiv.redlining-controlsbar input.redlining-label,\ndiv.redlining-controlsbar select.redlining-unit {\n    flex: 1 1 auto;\n    width: 0;\n    min-width: 5em;\n}\n\ndiv.redlining-shapewarning {\n    border-top: 1px solid var(--border-color);\n    margin-top: 0.25em;\n    padding-top: 0.25em;\n    font-size: 90%;\n    font-style: italic;\n}\n\nspan.redlining-control-icon {\n    margin-right: 0.125em;\n}\n\ndiv.redlining-marker-combo-entry {\n    display: flex;\n    align-items: center;\n    height: 16px;\n    width: 16px;\n}\n\ndiv.redlining-marker-combo-entry img {\n    /* Marker images are white, invert them to black */\n    filter: invert(1);\n    height: 100%;\n}\n\ndiv.redlining-message {\n    text-align: center;\n    font-style: italic;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
